import React from 'react';
import MUIBox, { BoxProps as MUIBoxProps } from '@material-ui/core/Box';

interface BoxProps extends MUIBoxProps {}

const Box = (props: BoxProps) => {
  return <MUIBox {...props}>{props.children}</MUIBox>;
};

Box.displayName = 'Box';

export default Box;
